import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { ethers } from "ethers";
import styled from "styled-components";
import Loading from "../../../Components/Loader";
import {
  Button,
  ButtonWrapper,
} from "../NftmarketGridStyledComponent";
import {
  allMetalordNFTContractsDeployed,
  isSupportedNFT,
  totalSupply,
  nftInfo,
} from "../NftMarketPage/contractData";
import ConfirmPopup from "../../../Components/ConfirmPopup";
// import {
//   getMetaspaceBaseApiURL
// } from "../../Pool/nftContractData";
import { nftContractABI } from "../../../config/data";
import { Circles } from "../../../theme";
import environmentVariables from "../../../config/environmentVariables";

const Root = styled.div``;
const Container = styled.div``;
const ActiveUpcomingContainer = styled.div``;
const NavSection = styled.div`
  display: flex;
  margin: 50px 0 30px 0;
`;
const H1 = styled.h1`
  margin: 0;
  font-size: 20px;
  color: #9f9f9f;
  ${(p) =>
    p.selected &&
    `
    color:#d5d5d5;
    `};
`;

const Link = styled.div`
  margin-right: 20px;
  font-size: 20px;
  font-weight: 600;
  text-align: center;
  padding: 5px 5px 10px 5px;
  color: #000;
  cursor: pointer;
  ${(p) =>
    p.selected &&
    `
      border-bottom: 1px solid #2e2e2e;
    `};
`;

const NftGridContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-gap: 40px 30px;
  @media (max-width: 1440px) {
    grid-template-columns: 1fr 1fr 1fr;
  }
  @media (max-width: 650px) {
    grid-template-columns: 1fr 1fr;
  }
  @media (max-width: 425px) {
    grid-template-columns: 1fr;
  }
`;

const NftGridWrapper = styled.div`
  backdrop-filter: blur(17.915px);
  border-radius: 20px;
  background-color: #151a1c;
  width: 100%;
  display: inline-block;
`;

const NftNewArivalWrapper = styled.div`
  display: flex;
  -webkit-box-pack: center;
  width: 90%;
  cursor: pointer;
  border-radius: 20px;
  background-color: #262a2d;
  margin: 5%;
  justify-content: center;
  align-items: center;
  overflow: hidden;
`;
export const NftCategory = styled.div`
  font-size: 9px;
  font-weight: 800;
  color: #490d81;
  text-transform: uppercase;
  background-color: #d3b1f3;
  padding: 7px 12px;
  border-radius: 50px;
  position: absolute;
  top: 25px;
  right: 25px;
  /* opacity: 0.7; */
  ${(p) =>
    p.rare &&
    `
    background-color: #a5e3b8;
    color: #2b713e;
  `};
  ${(p) =>
    p.common &&
    `
    background-color: #dddddd;
    color: #535353;
  `};
`;
const NftNewArival = styled.img`
  /* width: 90%;
  min-height: 350px;
    max-height: 350px;
    border-radius: 40px;
  padding: 20px 0;
  cursor: pointer; */
  /* max-height: 170px; */
  width: 100%;
  padding: 20px;
`;

const NftNameWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  text-align: start;
  align-items: center;
  width: 100%;
  padding: 2px 20px 5px 20px;
  @media (max-width: 1024px) {
    padding: 2px 15px 5px 15px;
  }
`;

const NftNameText = styled.text`
  font-size: 22px;
  font-weight: 600;
  margin: 4px 0;
  font-style: normal;
  padding: 10px 0px;
  line-height: 22px;
  text-transform: capitalize;
  color: #ffffff;
  /* font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 22px;
  text-transform: capitalize;
  color: #ffffff; */
`;

const PriceButtonContainer = styled.div`
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  margin: 20px 15px;
  justify-content: space-between;
  /* align-items: flex-start; */
  text-align: center;
  @media (max-width: 768px) {
    margin: 10px 17px 20px 17px;
  }
  @media (max-width: 1024px) {
    margin: 10px 17px 20px 17px;
  }
`;

const PriceWrapper = styled.div`
  line-height: 22px;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  text-align: left;
  ${(p) =>
    p.Pricevalue &&
    `
    display: flex;
    align-items: flex-start;
    text-align:end;
`}
`;

const Pricevalue = styled.div`
  font-style: normal;
  font-weight: 700;
  font-size: 22px;
  line-height: 20px;
  color: #25a8c5;
  margin: 5px 0 0px 0;
  text-align: start;
  display: flex;
  align-items: center;
`;
const PriceText = styled.text`
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  color: #8a8aa0;
  margin-bottom: 5px;
  text-align: start;
  /* font-style: normal;
font-weight: 400;
font-size: 12px;
line-height: 14px;
text-transform: uppercase; */
`;
const LiveButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  background: #203736;
  border-radius: 4px;
  padding: 5px 10px;
`;
const LiveLight = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 30px;
  background-color: white;
  margin: 0 3px;
`;
const LiveButton = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  line-height: 12px;
  text-transform: uppercase;
`;

const ActiveUpcomingNft = ({ allContractDetails }) => {
  const [pageLink, setPageLink] = useState("Active");
  const navigation = useNavigate();
  const [showCreatedPopup, setShowCreatedPopup] = useState(false);
  const [loading, setLoading] = useState(false);
  // const [allSupportedNftContract, setAllSupportedNftContract] = useState([]);
  const [allFeaturedData, setAllFeaturedData] = useState({});
  const [allAuctionData, setAllAuctionData] = useState();

  const AuctionDataHandle = () => {
    axios
      .get(
        `${environmentVariables?.apiUrl}/nftmarketplace/api/v1/getauctionednft`
      )
      .then((res) => {
        console.log("AuctionDataHandle", res);
        setAllAuctionData(res.data);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
      });
  };

  useEffect(() => {
    if (allContractDetails?.metalordNFTManagerContract) {
      getAllNftMarketplaceList();
    }
    AuctionDataHandle();
  }, []);

  useEffect(() => {
    if (allContractDetails?.metalordNFTManagerContract) {
      getAllNftMarketplaceList();
    }
  }, [allContractDetails]);

  const checkIsUSDT = (address) => {
    if (address === "0xc2132D05D31c914a87C6611C10748AEb04B58e8F") {
      return true;
    } else {
      return false;
    }
  };

  const convertedPrice = (currency, price) => {
    return checkIsUSDT(currency)
      ? Number(price) / 1000000
      : Number(price) / 1000000000000000000;
  };

  const getNFTContract = async (nftAddress) => {
    return new ethers.Contract(
      nftAddress,
      nftContractABI,
      allContractDetails?.signer
    );
  };

  const fetchNftDetail = async (address, index, url) => {
    const response = await axios.get(`${url}${address}/${index}`);
    return response.data;
  };

  const fetchFeaturedData = async (supportedArr) => {
    let arr = [];

    if (supportedArr?.length > 0) {
      supportedArr.map(async (contract) => {
        const nftContract = await getNFTContract(contract);

        // const metaspaceBaseApiURL = await getMetaspaceBaseApiURL(allContractDetails?.nftStakingContract)
        const metaspaceBaseApiURL = `${environmentVariables?.apiUrl}/nftmarketplace/api/v1/get_token_details/`;
        await totalSupply(nftContract)
          .then(async (supplyCount) => {
            let i = 0;
            while (i < Number(supplyCount)) {
              // console.log('i', i, Number(supplyCount))
              if (i === 100) {
                setAllFeaturedData([...arr]);

                return;
              }
              await nftInfo(
                allContractDetails?.metaspaceNFTMarketplaceContract,
                contract.toLowerCase(),
                i
              )
                .then(async (nftContractInfo) => {
                  if (Number(nftContractInfo["listingStage"]) === 2) {
                    const nftDetail = await fetchNftDetail(
                      contract.toLowerCase(),
                      i,
                      metaspaceBaseApiURL
                    );
                    arr.push({
                      supply: Number(supplyCount),
                      contract,
                      fetchDetails: nftDetail,
                      data: nftContractInfo,
                    });
                  }
                  i++;
                })
                .catch((err) => {
                  setAllFeaturedData([...arr]);

                  i++;
                });
            }
            setAllFeaturedData([...arr]);
          })
          .catch((err) => {
            console.log("err", err);
          });
      });
    } else {
      setLoading(false);
    }

    return arr;
  };

  const getAllNftMarketplaceList = async () => {
    setLoading(true);
    setShowCreatedPopup(false);
    // setAllSupportedNftContract([]);
    let i = 0;
    let arr = [];
    let supportArr = [];
    while (i !== null) {
      // console.log("i inside a while", i);
      await allMetalordNFTContractsDeployed(
        allContractDetails?.metalordNFTManagerContract,
        i
      )
        .then(async (res) => {
          if (res !== null) {
            arr.push(res);
            // console.log("res", res);

            await isSupportedNFT(
              allContractDetails?.metaspaceNFTMarketplaceContract,
              res
            )
              .then(async (allDetailsOfNft) => {
                // console.log("allDetailsOfNft", allDetailsOfNft);
                if (allDetailsOfNft === true) {
                  supportArr.push(res);
                }

                setShowCreatedPopup(false);
                i++;
              })
              .catch((err) => {
                setShowCreatedPopup(false);
                // setAllSupportedNftContract(supportArr);
                i = null;
              });
          } else {
            i = null;
          }
        })
        .catch((err) => {
          setShowCreatedPopup(false);
          // setAllSupportedNftContract(supportArr);
          i = null;
        });
    }
    // console.log("supportArr", supportArr);
    await fetchFeaturedData(supportArr);
  };

  const getTradeCurrency = (id) => {
    let answer = "";

    if (id === "0xc2132D05D31c914a87C6611C10748AEb04B58e8F") {
      answer = "USDT";
    }
    if (id === "0xca082498a1dE55c5d13C5AF2B10CA5e1957349E6") {
      answer = "MLD";
    }
    if (id === "0x0000000000000000000000000000000000001010") {
      answer = "MATIC";
    }

    return answer;
  };

  return (
    <>
      {loading && <Loading />}
      <Root>
        <Container>
          <ActiveUpcomingContainer>
            <NavSection>
              <Link
                selected={pageLink === "Active"}
                onClick={() => setPageLink("Active")}
              >
                <H1 selected={pageLink === "Active"}> Active & Upcoming </H1>
              </Link>
            </NavSection>

            {/* {pageLink === "Active" && (
              <NftGridContainer>
                {allFeaturedData?.length > 0 &&
                  allFeaturedData.map((nftDetail) => {
                    console.log("nftDetail", nftDetail);
                    return (
                      <NftGridWrapper>
                        <NftNewArivalWrapper
                         onClick={() => {
                          navigation(
                            `/nftdetails/${nftDetail?.contract.toLowerCase()}/${nftDetail?.fetchDetails?.tokenId}`
                          );
                        }}
                        >
                          <NftNewArival
                            src={nftDetail?.fetchDetails?.image || NewTrendingWeapon1}
                          />
                        </NftNewArivalWrapper>
                        <NftNameWrapper>
                          <NftNameText>
                            {" "}
                            {nftDetail?.fetchDetails?.name || "Pistol"}{" "}
                          </NftNameText>
                        
                        </NftNameWrapper>
                        <PriceButtonContainer>
                          <PriceWrapper>
                              <ButtonWrapper >
                  <Button>Place a Bid</Button>
                </ButtonWrapper>
                          </PriceWrapper>
                          <PriceWrapper Pricevalue>
                            <PriceText> Current Bid </PriceText>
                            <Pricevalue > 
                              <Circles bluecircle={true} uyiuy={true} />
                              {nftDetail?.data?.tradeCurrency && nftDetail?.data?.highestBid ? convertedDivPrice(nftDetail?.data?.tradeCurrency, nftDetail?.data?.highestBid) : ''} </Pricevalue>
                          </PriceWrapper>
                        </PriceButtonContainer>
                      </NftGridWrapper>
                    );
                  })}
              </NftGridContainer>
            )} */}

            {
              <NftGridContainer>
                {allAuctionData?.map((auctionItem, index) => {
                  // console.log("1212121212", auctionItem);
                  return (
                    <NftGridWrapper key={index}>
                      <NftNewArivalWrapper
                        onClick={() => {
                          navigation(
                            `/nftdetails/${auctionItem?.contractAddress?.toLowerCase()}/${
                              auctionItem?.tokenId
                            }`
                          );
                        }}
                      >
                        <NftNewArival
                          // src={nftDetail?.fetchDetails?.image || NewTrendingWeapon1}
                          src={auctionItem?.image}
                        />
                      </NftNewArivalWrapper>
                      <NftNameWrapper>
                        <NftNameText>{auctionItem?.name}</NftNameText>
                        <NftNameText>{auctionItem?.tokenId}</NftNameText>
                      </NftNameWrapper>
                      <PriceButtonContainer>
                        <PriceWrapper>
                          <ButtonWrapper
                            onClick={() => {
                              navigation(
                                `/nftdetails/${auctionItem?.contractAddress?.toLowerCase()}/${
                                  auctionItem?.tokenId
                                }`
                              );
                            }}
                          >
                            <Button>Place a Bid</Button>
                          </ButtonWrapper>
                        </PriceWrapper>
                        <PriceWrapper Pricevalue>
                          <PriceText> Current Bid </PriceText>
                          <Pricevalue>
                            <Circles bluecircle={true} uyiuy={true} />
                            {auctionItem?.price}{" "}
                          </Pricevalue>
                        </PriceWrapper>
                      </PriceButtonContainer>
                    </NftGridWrapper>
                  );
                })}
              </NftGridContainer>
            }
          </ActiveUpcomingContainer>
        </Container>
        {showCreatedPopup && (
          <ConfirmPopup
            showPopup={showCreatedPopup}
            setShowPopup={setShowCreatedPopup}
            onClickFun={getAllNftMarketplaceList}
            text={`Congratulation you get data successfully.`}
          ></ConfirmPopup>
        )}
      </Root>
    </>
  );
};

export default ActiveUpcomingNft;
